// File: app.component.ts
// Author: Joseph M Diaz
// Date: 4/20/2017
// Desc: Root component for the app.
// Other Contributors: Brandon Shreve

import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { config } from '../config/config';
import { AppService } from './app.service';
import { CgpIdleService } from './shared/cgp-idle/cgp-idle.service';
import { CgpBreadcrumbsService } from './shared/cgp-breadcrumbs/cgp-breadcrumbs.service';
import { cgpAuthentication } from '../modules/cgp-authentication';
import { UserService, UserLastLoginDateService } from './components/mesc/mesc.service';
import { getEnv } from '../modules/utility';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'cgp-app',
    templateUrl: './app.template.html',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    @ViewChild('cgpContentContainer', { static: true }) private cgpContentContainer: ElementRef;
    @ViewChild('cgpSidebarContainer', { static: true }) private cgpSidebarContainer: ElementRef;

    public sidenavVisible = false;
    private userObject: any;

    constructor(
        private router: Router,
        public appService: AppService,
        // private cgpBreadcrumbsService: CgpBreadcrumbsService,
        private cgpIdleService: CgpIdleService,
        private userService: UserService,
        private userLastLoginDateService: UserLastLoginDateService
    ) {
        var self = this;
        this.appService.appComponent = this;
        this.cgpIdleService.startTimers();
        var userInfo = cgpAuthentication.getUserInfo();
        this.userService.read("", true).then(function (response) {
            try {
                self.userObject = response.filter(function (user) {
                    return user.GMIN.toString() === userInfo.gmuniqueidentifier || userInfo.gmin;
                });

                self.userObject = Array.isArray(self.userObject) ? self.userObject[0] : undefined;

                if (self.userObject) {
                    var date = new Date();
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();
                    var hour = date.getHours();
                    var minute = date.getMinutes();
                    var second = date.getSeconds();
                    var datetime = month + "/" + day + "/" + year + " " + hour + ':' + minute + ':' + second;

                    self.userObject.LastLogonDate = datetime;
                    self.userLastLoginDateService.save(self.userObject, false, '?lastLoginDate=' + self.userObject.LastLogonDate);
                }
            } catch (e) { }
        })
    }

    ngOnInit() {

        let self = this;

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event) => {
                let url = (event as any).url || '';
                let urlArray = url.split('/');
                let baseUrl = urlArray[1];
                let breadcrumbs = config.breadcrumbs[baseUrl];
                let sidenavContentContainer = self.cgpSidebarContainer.nativeElement.querySelector('.mat-sidenav-content');

                // if (breadcrumbs) {
                //     self.cgpBreadcrumbsService.updateBreadcrumbs(breadcrumbs);;
                // }
                // else {
                //     self.cgpBreadcrumbsService.updateBreadcrumbs(config.breadcrumbs["404"]);
                // }

                sidenavContentContainer.scrollTop = 0;
                sidenavContentContainer.scrollLeft = 0;
            });
    }

    @HostListener('window:mousemove')
    onMouseMove() {
        this.cgpIdleService.setIsActive();
    }

    @HostListener('window:mousedown')
    onMouseDown() {
        this.cgpIdleService.setIsActive();
    }

    @HostListener('window:keydown')
    onKeyDown() {
        this.cgpIdleService.setIsActive();
    }
}
